import React, { useEffect, useState } from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import {  useNavigate,Link } from 'react-router-dom';
import { useAuthContext } from '../hooks/useAuthContext';
import { useAllFlashes } from "../hooks/useAllFlashes";
// import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import {useSubscription} from "../hooks/useSubscription";
// import Pagination from "../Components/Flashes-Pagination";
import { MdDeleteForever } from "react-icons/md";
// import { CheckExpiration } from "../middle/refreshToken";
import dayjs from 'dayjs';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { jwtDecode } from "jwt-decode";
import Cookies from "js-cookie";
import { useContentsContext } from "../hooks/useContentsContext";
import { Helmet } from "react-helmet";
import {useLogout} from "../hooks/useLogout";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
 function Flashes() {

  const { user,dispatch } = useAuthContext()
  // const { fetchFlashes } = useAllFlashes()
  const {allFlashes,customFlashData} = useAllFlashes()
//  const[loading,isLoading] = useState(false);
//   const [flashes, setFlashes] = useState("")
//   const [flashCount,setCount] = useState("");
//   const[subsData,setData] = useState();
const {logout} = useLogout();
const{subsInfo} = useSubscription()

  const [search, setSearch] = useState("")
  const {  dispatchcontent } = useContentsContext()
  // const fetFlashes = async () => {
  //   isLoading(true)
  //    console.log("loadded")
  //   const response = await fetchFlashes()
  //   isLoading(false)
  //   console.log("loadded")
  //   console.log(response)
  //    setCount(response.length)
  //   setFlashes(response)

  // }

  //handle payment
//   const handlePayment = async(e) =>{
//     e.preventDefault()

//     const response = await fetch('/checkout-session', {
//       method: 'POST',
//       headers: {'Content-Type':'application/json', 
//       'Authorization': `Bearer ${user}`
//   },
//       body: JSON.stringify({priceId:"price_1OMuSLSAHivKNSZavvRrUdLN"})
//   })
//   const json = await response.json()
  
// window.location.href=json.url;
//   }
  // const handleSubs = async() =>{
  //   const data = await getSubs()
    
  //   setData(data)



  // }
  

  const navigate = useNavigate()

  useEffect(() => {
    const users = Cookies.get('token')
    
     if(!users ){
      logout()
    }
try{

    const User = jwtDecode(users)
   
    const checkToken = async() =>{
    
      const isExpired = dayjs.unix(User.exp).diff(dayjs())< 1;
    if(!isExpired){
     
      // fetFlashes()
 

    }else{
 
    
      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/user/refresh-token`, {
        method: 'GET',
        headers: {'Content-Type':'application/json',
    },
    credentials:'include'
    })
   
  if(response.status === 200){
    
     const json = await response.json()
     dispatch({ type: 'LOGIN', payload: json.token })
     navigate("/")
  }else{

    logout()
  }
    }
  
  }
    
  
  
  checkToken()
}catch(e){

  if(e.message.includes("Invalid token specified")){
    logout()
    }
}
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleDelete = async (deleteHis) => {

      const response = await fetch(`${process.env.REACT_APP_API_URL || "http://localhost:4000"}/api/delete-saved-flash/` + deleteHis, {
        method: "DELETE",
        headers: {
          'Authorization': `Bearer ${user}`
        }
    
      })
      const json = await response.json()
    
      if (!response.ok) {
    toast("Something went wrong")
      }
      if (response.ok) {
        toast("Deleted Successfully")
        dispatchcontent({ type: 'DELETE_CONTENTS', payload: json })
    
      }
    }

  if (user) {




    return (






      <div className=" text-black min-h-screen lg:w-3/4 md:w-3/4 sm:w-3/4 w-2/3 mx-auto">
<Helmet>
                <meta charSet="utf-8" />
                <title>Flashes - Content Flash AI</title>
               <meta name="description" content="Content Flash AI is an AI based content generator. Generate blogs, emails,etc in seconds."/>
            </Helmet>
      {
     subsInfo && subsInfo.status !== "active" ?
      
     
      <div className="dark:bg-none dark:bg-gray-900 pt-2">
   
   
     </div>
      :
      
      null
        
      } 

<Tabs
          
          defaultActiveKey="flash"
          id="fill-tab-example"
          className="mt-5 mb-3 tab font-normal text-black"
          nav-justified
          nav-fill
        >
          <Tab eventKey="flash" title="Content Creation Flashes">

        
           <h1 className="mt-10 dark:text-white  py-2 text-left  font-Rajdhani bg-gradient-to-r from-black from 1% via-red-500  to-orange-600 to-100% inline-block text-transparent bg-clip-text">Content Creation Flashes - 67 </h1>
   
    <div className="">
    {/* { subsData && subsData.details.words >=2000 ?
        subsData.status === "inactive" ?    
        <div className="absolute flex dark:bg-gradient-to-t  dark:from-orange-100 dark:from-1% dark:to-transparent dark:to-90% backdrop-blur-sm inset-0 bg-opacity-75 text-center justify-center items-center">

{/* <div className="ring-1 dark:bg-[#2e3247] rounded-md dark:text-white ring-black p-3" >
<p className="mt-2 mb-4 text-base leading-6 text-gray-900 font-semibold text-xl dark:text-white ">
            Flash Premium
              </p>
            <h3 className="mt-1 mb-1 text-5xl leading-6 text-gray-900 font-bold dark:text-white">
                $25/mo
              </h3>
            <ul className="my-8">
            <li className="my-3 text-base leading-6  flex">
                <IoIosCheckmarkCircleOutline className="mr-1 text-orange-700" size={25}/>   Unlimited Words
                </li>
                <li className="my-3 text-base leading-6  flex">
                <IoIosCheckmarkCircleOutline className="mr-1 text-orange-700" size={25}/>   100 Ai Images
                </li>
                <li className="my-3 text-base leading-6  flex">
                <IoIosCheckmarkCircleOutline className="mr-1 text-orange-700" size={25}/>  Latest Model: GPT-4
                </li>
                <li className="my-3 text-base leading-6  flex">
                <IoIosCheckmarkCircleOutline className="mr-1 text-orange-700" size={25}/>   100+ Flash Templates
                </li>
                <li className="my-3 text-base leading-6  flex">
                <IoIosCheckmarkCircleOutline className="mr-1 text-orange-700" size={25}/>   Free Updates
                </li>
              </ul>
              <form  className="mb-3" method="POST" onSubmit={handlePayment}>
      <button type="submit" className="bg-orange-700 rounded no-underline text-white p-2" >Upgrade now!</button>

    </form>
  </div> */}


 

    {/* </div> */}
         {/* :null  : null */}
    
{/* 
    {allFlashes && allFlashes.map((flash)=>(
              <h1>{flash.title}</h1>

    ))}     */}
{/* <Pagination data={allFlashes} /> */}
       {/* .filter((flash) => {
      return search.toLowerCase() === '' ? flash : flash.title.toLowerCase().includes(search) 
     }) */}
<div className="flex shadow-sm my-4 border-1 border-slate-300 font-normal">
          <input
            type="search"
            name="search"
            id="search"
            placeholder="search....start typing..."
            className="dark:bg-[#2c2f44] dark:text-[#99a0ac] w-full px-3 text-gray-900 outline-none py-1 focus:outline-none"
            onChange={(e) => setSearch(e.target.value)}
          />

        </div>
<div className=" grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 pb-10 ">
<div className="rounded ring-1 ring-slate-300 p-3 hover:shadow-xl dark:bg-[#2e3247] dark:ring-0 dark:hover:ring-1 dark:rounded-2xl">
<Link className="no-underline " role="button" to="/dynamic">
<span className=" dark:bg-[#2e3247] dark:text-white font-Rajdhani  dark:ring-1 dark:ring-[#99a0ac]  bg-orange-100 text-orange-800 text-sm font-bold px-2.5 py-0.5 rounded light:bg-gray-700 light:text-orange-400 light:border light:border-red-400 ">🔥 Hot Flash</span>

<div class="d-flex position-relative align-items-center mt-3 ">
          <img src="/assets/custom.png"   className=" overflow-hidden w-10 bg-slate-200  rounded-full" alt=""/>
         
        </div>
<h5 className="dark:text-white text-slate-800 font-Sarabun font-medium  mt-3">Custom Flash! 🪄</h5>
      <p className="dark:text-[#99a0ac] font-normal text-md font-Sarabun text-slate-600">Generate your custom flash form for your use-case</p>
      { subsInfo && 

subsInfo.status === "inactive" 

?subsInfo.details.words >=subsInfo.details.totalwords    ?
<div>
<p className="font-Rajdhani text-red-600 dark:text-red-400">Upgrade to premium or wait for a month to continue using flash.</p>


          </div>

: null : null }
</Link>
  </div>
  {allFlashes && allFlashes.filter((flash) => {
      return search.toLowerCase() === '' ? flash : flash.title.toLowerCase().includes(search) 
     }).map((flash) => (
      <Link className="no-underline " role="button" to={`/flashes${flash.url}`}>

      <div className="rounded ring-1 ring-slate-300 p-3 hover:shadow-xl dark:bg-[#2e3247] dark:ring-0 dark:hover:ring-1 dark:rounded-2xl">
  
        <span className=" dark:bg-[#2e3247] dark:text-white font-Rajdhani  dark:ring-1 dark:ring-[#99a0ac]  bg-orange-100 text-orange-800 text-sm font-bold px-2.5 py-0.5 rounded light:bg-gray-700 light:text-orange-400 light:border light:border-red-400 ">{flash.status}</span>
        <div class="d-flex position-relative mt-3 align-items-center ">
                                                          <div class="position-absolute  opacity-10 top-0 right-0 bottom-0 left-0 "></div>
            
              <div
         
                  dangerouslySetInnerHTML={{ __html: flash.icon }}
                  className="bg-red-400 overflow-hidden  rounded-full"
              // Set width and height to 100% to fill the parent div
              />
          </div>
  
  
        <h5 className="dark:text-white text-slate-800 font-Sarabun font-medium  mt-3" key={flash._id}>{flash.title}</h5>
        <p className="dark:text-[#99a0ac] font-normal text-md font-Sarabun text-slate-600">{flash.description}</p>
  
        {/* <Link className="btn bg-gradient-to-r from-red-700 to-red-600 text-white  hover:scale-105" role="button" to={flash.url}>
  Try Now
  </Link> */}
  
  { subsInfo && 
  
        subsInfo.status === "inactive" 
  
        ?subsInfo.details.words >=subsInfo.details.totalwords    ?
        <div>
        <p className="font-Rajdhani text-red-600 dark:text-red-400">Upgrade to premium or wait for a month to continue using flash.</p>
     
  
                  </div>
        
        : null : null }
      </div>
      </Link>
  ))} 

</div>


</div>

</Tab>
<Tab eventKey="Custom" title="My Custom Flashes">
            
            <h1 className="mt-10 dark:text-white  py-2 text-left  font-Rajdhani bg-gradient-to-r from-black from 1% via-red-500  to-orange-600 to-100% inline-block text-transparent bg-clip-text">Custom Flashes </h1>
     
  
   {/* <div className=" grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 pb-10 ">
  {customFlashData && customFlashData.map((cFlash)=>{
  
    return(
      <div>
  
      <Link className="btn dark:bg-[#818998] dark:text-white dark:bg-none dark:rounded-2xl dark:hover:scale-105 dark:hover:bg-[#818998] dark:hover:text-white   bg-gradient-to-r  hover:scale-105" role="button" to={`/dynamic${cFlash.Url}`}>
  
     <div className="rounded ring-1 ring-slate-300 p-3 hover:shadow-xl dark:bg-[#2e3247] dark:ring-0 dark:rounded-2xl">
  
  <h5 className="dark:text-white font-sans  mt-3" key={cFlash.formName}>{cFlash.Flash.FormName}</h5>
       <p className="dark:text-[#99a0ac] font-normal text-sm font-mono">{cFlash.Flash.FormTagline}</p> 
    
  </div>
  </Link> 
  </div>
    )
  })}
  
  
  </div>  */}
    { customFlashData?.length >0?
  <div className=" grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 pb-10 ">
  {
  customFlashData && customFlashData.map((cFlash)=>{
    return(
  <Link className="no-underline " role="button" to={`/dynamic${cFlash?.Url}`}>
  
  
  <div className="rounded ring-1 ring-slate-300 p-3 hover:shadow-xl dark:bg-[#2e3247] dark:ring-0 dark:hover:ring-1 dark:rounded-2xl">
  
  <div className="flex justify-between ">
  <span className=" dark:bg-[#2e3247] dark:text-white font-Rajdhani  dark:ring-1 dark:ring-[#99a0ac]  bg-orange-100 text-orange-800 text-sm font-bold px-2.5 py-0.5 rounded light:bg-gray-700 light:text-orange-400 light:border light:border-red-400 ">Custom</span>
  {/* eslint-disable-next-line no-sequences */}
<MdDeleteForever  className="text-2xl text-red-500  rounded-full hover:bg-red-200 " onClick={(e)=>(e.preventDefault(), handleDelete(cFlash.uuid))}/>
  
  </div>
  
    <img src="/assets/custom.png"   className=" overflow-hidden w-10 mt-3 bg-slate-200  rounded-full" alt=""/>
           
  
  {/* 
    <h5 className="dark:text-white font-Rajdhani  mt-3" key={cFlash?.Flash?.formName}>{cFlash?.Flash?.FormName}</h5>
       <p className="dark:text-[#99a0ac] font-normal text-sm font-mono">{cFlash?.Flash?.FormTagline}</p>  */}
      <h5 className="dark:text-white text-slate-800 font-Sarabun font-medium  mt-3" key={cFlash?.Flash?.FormName}>{cFlash?.Flash?.FormName}</h5>
        <p className="dark:text-[#99a0ac] font-normal text-md font-Sarabun text-slate-600">{cFlash?.Flash?.FormTagline}</p>
  
        { subsInfo && 
  
  subsInfo.status === "inactive" 
  
  ?subsInfo.details.words >=subsInfo.details.totalwords    ?
  <div>
  <p className="font-Rajdhani text-red-600 dark:text-red-400">Upgrade to premium or wait for a month to continue using flash.</p>
  
  
            </div>
  
  : null : null }
  </div>
  </Link>
    )
  
  }) 
  }
  
  </div>
  :
  <p className="font-Rajdhani text-2xl dark:text-white">No Custom Flash Found. <Link to="/dynamic" >Create Now!</Link></p>
  }
  
            </Tab>
</Tabs>
   

<ToastContainer
                    position="top-right"
                    autoClose={2000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                  />
</div>

  
  

    );

  }else{
    return navigate("/")
  }
}


export default Flashes;